/**
 * SafeRoads AppConfig — stub. See safeintersections/config.ts for notes;
 * this file is structurally identical with SafeRoads identifiers.
 */

import { goto } from '$app/navigation';
import { resolve } from '$app/paths';
import type { AppConfig } from '#lib/apps/types.js';
import LogoSafeRoads from '#lib/assets/logos/saferoads.svg?raw';
import { loadSystemLayers } from '#lib/common/loaders.js';

// Placeholder until SafeRoads ships its first dataset; until then no real api key has it.
const SR_DATASET = 'saferoads';

export const saferoadsConfig: AppConfig = {
	id: 'saferoads',
	name: 'SafeRoads Professional',
	basePath: '/saferoads',
	head: {
		title: 'Abley SafeRoads Professional',
		description: 'Proactive, data-driven tools to identify road safety risks.',
		keywords: 'SafeSystem, SafeRoads, Abley Ltd.'
	},
	logo: LogoSafeRoads,
	basemap: 'no-roads',
	version: '0.0.0',
	datasets: [SR_DATASET],

	loaders: {
		// No builder yet: empty shells when the key has SafeRoads data, "Data not available" otherwise.
		system: (apiKey) =>
			loadSystemLayers(apiKey, [SR_DATASET], (layers) => (layers.length ? {} : null))
	},

	legends: [],

	table: {
		tabs: [],
		defaultTabId: ''
	},

	filters: [],

	dashboard: {
		widgets: [],
		backgroundImage: '/landing_bg.webp'
	},

	header: {
		dashboard: {
			label: 'Dashboard',
			action: () => void goto(resolve('saferoads'))
		},
		playbook: () => ({ label: 'Playbook', href: '#' }),
		help: []
	},

	attributes: {
		panel: null,
		countermeasures: null
	}
};
